import { GetCases, InspirationToCase, OpsCases, WorkToCase } from '../../../entities';
import { VAxios } from '../../define/axios/Axios';
import { PageWrapper } from '../../entities/base/base.entities';
import {
  OpsAbility,
  OpsAd,
  OpsClassificationTree,
  OpsParams,
  OpsStyle,
  OpsTip,
  OpsCaseDetail,
  EditorToCase,
} from '../../entities/ops/ops.entities';

export const createApi = (defHttp: VAxios) => ({
  //#region 获取参数配置
  // 查询参数节点树🌲
  getTree: (params) => defHttp.get<OpsClassificationTree>({ url: `/aiad/params/nodes`, params }),

  // 查询参数节点成员列表
  getParams: (params) =>
    defHttp.get<PageWrapper<OpsParams>>({ url: `/aiad/params/nodes/members`, params }),
  //#endregion

  // 资源位查询
  getAds: (params) => defHttp.get<OpsAd[]>({ url: `/aiad/ads`, params }),

  // 获取 tips
  getTips: () =>
    defHttp.get<{
      items: OpsTip[];
      ratio: number;
    }>({ url: '/aiad/prompts' }),

  getAbility: (code: string) => defHttp.get<OpsAbility>({ url: `/aiad/work/abilities/${code}` }),

  //查询所有能力说明信息
  getCommonAbilities: () => defHttp.get<OpsAbility[]>({ url: '/aiad/creations/common/abilities' }),

  getStyles: () => defHttp.get<OpsStyle[]>({ url: `/aiad/creations/styles` }),

  getInspStyles: () => defHttp.get<OpsStyle[]>({ url: `/aiad/inspiration/creations/styles` }),

  getCommonStyles: (params?: { category?: string; pageSize?: number; ability?: string }) =>
    defHttp.get<{
      pages: number;
      totals: number;
      items: OpsStyle[];
    }>({ url: `/aiad/creations/common/styles`, params }),

  getMyCommonStyles: () => defHttp.get({ url: `/aiad/creations/common/styles/custom` }),

  workToCase: (params: WorkToCase) => {
    return defHttp.post<string>({ url: `/aiad/cases/work`, params });
  },

  inspirationToCase: (params: InspirationToCase) => {
    return defHttp.post<string>({ url: `/aiad/cases/inspiration`, params });
  },

  editorToCase: (params: EditorToCase) => {
    return defHttp.post<string>({ url: `/aiad/cases/editor`, params });
  },

  // 获取案例列表
  getCases: (params: GetCases) => {
    return defHttp.get<OpsCases>({ url: `/aiad/cases/page`, params });
  },

  // 获取案例详情
  getCaseDetail: (id: string | number) => {
    return defHttp.get<OpsCaseDetail>({ url: `/aiad/cases/${id}` });
  },

  // 复用案例详情
  useCaseDetail: (id: string) => {
    return defHttp.post<string>({ url: `/aiad/cases/${id}` });
  },

  // 搜索案例
  searchCases: (params) => {
    return defHttp.get<string>({ url: `/aiad/cases/search`, params });
  },
});
